<template>
  <div class="Options">   
    <div ref="title" class="Options__title">Select an <span>option</span></div>
    <div ref="weave" class="Options__block" @click="onClick('weave')">  
      <div><span>Weave</span> in <span>Augmented Reality</span></div>
      <div class="Options__desc">Interact with a virtual loom in your living space</div>
    </div>
    <div class="Options__space"/>
    <div ref="share" class="Options__block share" @click="onClick('share')">  
      <div><span>Share story</span></div>
      <div class="Options__desc">Record or write a story about your lived experience</div>
    </div> 
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Options',
  mounted() {

    // this.$parent.introCompleted()
    // return

    this.$nextTick(()=>{

      gsap.from([ this.$refs.title, this.$refs.weave, this.$refs.share ], {
        duration: .5, 
          y: '+=300%',
          opacity: 0, 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .25, 
      })
    })

    // this.$parent.introCompleted()
    // #241F3F
    
  },
  methods:{
    onClick(arg) {

      gsap.to([ this.$refs.title, this.$refs.weave, this.$refs.share ], {
        duration: .25, 
        stagger: .25,
        ease: 'none',
        opacity: 0,
        delay: .25,
        onComplete: ()=>{
          this.$parent.optionCompleted(arg)
        }
      })
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Options
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content center
  align-items center
  z-index 20000

  & span 
    font-weight 900

  &__title
    position relative
    text-align center
    font-family SpaceGrotesk
    font-size 1.88em
    width 100%
    height 12.5%

  &__block 

    width 72%
    padding 8%
    border 2px solid #8073DD
    background rgb(93, 72, 209)
    background linear-gradient(0deg, rgba(93, 72, 209, 1) 50%, rgba(107, 61, 172, 1) 100%)

    border-radius 32px
    display flex
    align-items center
    justify-content center
    flex-direction column
    font-size 1.38em
    cursor pointer
    text-align center

    &.share 
      border 2px solid #AE67C9
      background rgb(157, 75, 82)
      background linear-gradient(0deg, rgba(157, 75, 82, 1) 50%, rgba(136, 35, 172, 1) 100%)

  &__desc 
    font-size .88em
    line-height 1.19em
    padding-top 8%

  &__space
    height 4%



</style>


